import { combineReducers } from 'redux'
import omit from 'lodash/omit'

// ACTIONS
export const UPDATE_SUCCESS = 'company/candidateList/candidates/UPDATE_SUCCESS'
export const UPDATE_FROM_DETAILS = 'company/candidateList/candidates/UPDATE_FROM_DETAILS'

export const SET_FAVOURITE_SUCCESS = 'company/candidateList/candidate/SET_FAVOURITE_SUCCESS'
export const UNSET_FAVOURITE_SUCCESS = 'company/candidateList/candidate/UNSET_FAVOURITE_SUCCESS'

export const RESET_ALL = 'company/candidateList/candidates/RESET_ALL'

export const TOGGLE_LOADING = 'company/candidateList/candidates/TOGGLE_LOADING'
export const TOGGLE_LOADING_MORE = 'company/candidateList/candidates/TOGGLE_LOADING_MORE'

// ACTION CREATORS
export const toggleLoading = loading => ({
  type: TOGGLE_LOADING,
  payload: { loading },
})

export const toggleLoadingMore = loadingMore => ({
  type: TOGGLE_LOADING_MORE,
  payload: { loadingMore },
})

export const updateSuccess = ({ result }) => ({
  type: UPDATE_SUCCESS,
  payload: { ...result },
})

export const updateFromDetails = result => ({
  type: UPDATE_FROM_DETAILS,
  payload: result,
})

export const setFavouriteSuccess = data => ({
  type: SET_FAVOURITE_SUCCESS,
  payload: data,
})

export const unsetFavouriteSuccess = payload => ({
  type: UNSET_FAVOURITE_SUCCESS,
  payload,
})

export const resetAll = () => ({
  type: RESET_ALL,
})

// REDUCERS
const defaultUtils = {
  loading: true,
  loadingMore: false,
  error: null,
}

const utils = (state = defaultUtils, { type, payload }) => {
  switch (type) {
    case TOGGLE_LOADING:
    case TOGGLE_LOADING_MORE:
      return {
        ...state,
        ...payload,
      }

    case RESET_ALL:
      return defaultUtils

    default:
      return state
  }
}

const collection = (state = [], { meta, type, payload }) => {
  switch (type) {
    case UPDATE_FROM_DETAILS:
      return state.map(elem => {
        if (elem.id === payload.id) {
          return {
            ...elem,
            interview_request_per_hiring_team: [payload],
          }
        }

        return elem
      })

    case UPDATE_SUCCESS:
      return state.map(elem => {
        if (elem.id === payload.id) {
          return {
            ...elem,
            ...payload,
          }
        }

        return elem
      })

    case SET_FAVOURITE_SUCCESS:
      return state.map(candidate => {
        if (candidate.id === payload.candidate_id) {
          return {
            ...candidate,
            likes: {
              ...candidate.likes,
              [payload.creator_id]: payload,
            },
          }
        }

        return candidate
      })

    case UNSET_FAVOURITE_SUCCESS:
      return state.map(elem => {
        if (elem.id === payload.id) {
          return {
            ...elem,
            likes: omit(elem.likes, payload.creator_id),
          }
        }

        return elem
      })

    case RESET_ALL:
      return []

    default:
      return state
  }
}

const defaultPagination = {
  current_page: 0,
  total_pages: 0,
  items_per_page: 20,
  total_items: 0,
}

const pagination = (state = defaultPagination, { type, payload }) => {
  switch (type) {
    case RESET_ALL:
      return defaultPagination

    default:
      return state
  }
}

export default combineReducers({
  utils,
  collection,
  pagination,
})
